module.exports = __webpack_public_path__ + "static/media/wrinkles.ce92ad7e.svg";